import React, { useState } from "react";
import { SeoAnalysisReport } from "../seoAnalyzer";
import { Copy, Check, FileCode, Tag } from "lucide-react";

interface RawMetadataViewerProps {
  meta: SeoAnalysisReport["meta"];
  metrics: SeoAnalysisReport["metrics"];
}

export const RawMetadataViewer: React.FC<RawMetadataViewerProps> = ({ meta, metrics }) => {
  const [copiedSection, setCopiedSection] = useState<string | null>(null);

  const copyToClipboard = (key: string, text: string) => {
    navigator.clipboard.writeText(text);
    setCopiedSection(key);
    setTimeout(() => setCopiedSection(null), 2000);
  };

  const metaTagsJson = JSON.stringify(meta, null, 2);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      {/* Extracted Head Meta Tags */}
      <div className="cyber-card">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <h3 style={{ fontSize: "1rem", color: "var(--neon-cyan)", display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Tag size={18} /> HTML HEAD METADATA MATRIX
          </h3>
          <button className="copy-btn" onClick={() => copyToClipboard("meta", metaTagsJson)}>
            {copiedSection === "meta" ? <Check size={14} color="var(--neon-emerald)" /> : <Copy size={14} />}
            <span>{copiedSection === "meta" ? "COPIED" : "COPY METADATA JSON"}</span>
          </button>
        </div>

        <div className="code-box">
          <pre>
            <code>{metaTagsJson}</code>
          </pre>
        </div>
      </div>

      {/* JSON-LD Schemas */}
      <div className="cyber-card">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <h3 style={{ fontSize: "1rem", color: "var(--neon-purple)", display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <FileCode size={18} /> STRUCTURED DATA (JSON-LD SCHEMAS)
          </h3>
        </div>

        {metrics.jsonLdTypes.length > 0 ? (
          <div>
            <p style={{ fontSize: "0.85rem", color: "var(--text-secondary)", marginBottom: "0.75rem" }}>
              Detected Schema Types:{" "}
              {metrics.jsonLdTypes.map((t) => (
                <span
                  key={t}
                  style={{
                    background: "rgba(157, 78, 221, 0.15)",
                    border: "1px solid var(--neon-purple)",
                    color: "var(--neon-purple)",
                    padding: "0.2rem 0.5rem",
                    borderRadius: "4px",
                    fontFamily: "var(--font-mono)",
                    fontSize: "0.75rem",
                    marginRight: "0.4rem",
                  }}
                >
                  {t}
                </span>
              ))}
            </p>
          </div>
        ) : (
          <p style={{ color: "var(--text-muted)", fontSize: "0.85rem" }}>
            No JSON-LD schema blocks were discovered in document head or body.
          </p>
        )}
      </div>
    </div>
  );
};
